import React from 'react';
import Layout from '../util/layout';
import background from '../img/6.png';

const Santander = () => {
	return(
        <Layout title="BSC Rwanda">
            <div className="page-content">
                <section data-padding="top">
                    <div className="container">
                        <div data-aos="fade-up" className="row aos-init aos-animate">
                            <div className="col-12">
                                <div className="sectiontitle-element--center">
                                    <h2>Amazon Digital Office For Banking Industry</h2>
                                </div>
                                <div className="sectiontitle-element">
                                    <p data-aos="fade-up" data-aos-delay="200" className="aos-init aos-animate">Using the Amazon Digital Office banks will be able to convert their existing paper based complaints and other processes into automated integrated paperless process for customers.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row align-items-lg" data-padding="xstop">
                            <div data-aos="zoom-in" className="col-12 col-lg-6 aos-init">
                                <div className="wrapimage-element--square">
                                    <div className="image">
                                        <img src={background}  alt="" />
                                    </div>
                                </div>
                            </div>
                            <div data-aos="fade" data-aos-delay="200" className="col-12 col-lg-6 aos-init">
                                <div className="icon-element" data-padding="">
                                    <div className="info">
                                        <div className="text">
                                            <h6>The Problem</h6>
                                            <p>Santander had a number of forms that were completed by all 26,000 UK staff members a number of times each year. This includes the likes of Health & Safety forms, conduct risk, holiday request forms and many others.</p>
                                            <p>The problem is that each person had to print out the form, complete and sign it, then scan the form and email it to their managers to complete their section of the forms.</p>
                                            <p>This process was time consuming, involved significant amounts of printing, extensive use of ink and tonner as well as all the environmental and financial costs associated with using, processing and storing paper.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="icon-element" data-padding="">
                                    <div className="info">
                                        <div className="text">
                                            <h6>The Solutions</h6>
                                            <p>Amazon Digital Office technicians were asked to review, analyse and resolve the paper forms and associated processes. The team instantly digitized all the forms and converted them to fully integrated paperless workflow forms that staff and customers can securely complete and submit using smartphones, tablets or PCs from any location.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="icon-element" data-padding="">
                                    <div className="info">
                                        <div className="text">
                                            <h6>Outcome</h6>
                                            <p>The benefits were instantly realized from the same day of implementation (which was within hours of the forms being provided). This includes immediate reduction of costs such as paper, printers,  ink, toner, and more significantly the time required to process the paper forms. A number of staff members were able to be re-deployed to other activities and make better use of their time. There has also been a total cut in physical storage costs.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </Layout>
    );
}

export default Santander;